(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ca-ref-filters').forEach((filters) => {
    const grid = filters.parentElement.querySelector('[data-filter-grid]');
    if (!grid) return;
    const applyFilter = (filter) => {
      filters.querySelectorAll('button').forEach((button) => button.classList.toggle('is-active', button.dataset.filter === filter));
      grid.querySelectorAll('[data-product-category]').forEach((card) => { card.hidden = filter !== 'all' && card.dataset.productCategory !== filter; });
    };
    filters.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.filter)));
    document.querySelectorAll('[data-filter-link]').forEach((link) => link.addEventListener('click', () => applyFilter(link.dataset.filterLink)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["entry-journey"]) return;
  try {
    
  (() => {
    const entry = document.querySelector('[data-entry-journey]');
    if (!entry || (window.Shopify && window.Shopify.designMode)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || sessionStorage.getItem('ca-entry-seen')) return;
    entry.hidden = false;
    document.body.classList.add('ca-entry-active');
    let progress = 0;
    let touchY = 0;
    let finishing = false;
    const update = (delta) => {
      if (finishing) return;
      progress = Math.max(0, Math.min(1, progress + delta));
      entry.style.setProperty('--entry-progress', progress.toFixed(3));
      if (progress >= 1) finish();
    };
    const finish = () => {
      if (finishing) return;
      finishing = true;
      sessionStorage.setItem('ca-entry-seen','1');
      entry.classList.add('is-revealing');
      document.body.classList.remove('ca-entry-active');
      setTimeout(() => entry.remove(), 720);
    };
    entry.addEventListener('wheel', (event) => { event.preventDefault(); update(Math.max(-80,Math.min(120,event.deltaY)) / 520); }, { passive:false });
    entry.addEventListener('touchstart', (event) => { touchY = event.touches[0].clientY; }, { passive:true });
    entry.addEventListener('touchmove', (event) => { event.preventDefault(); const next = event.touches[0].clientY; update((touchY - next) / 480); touchY = next; }, { passive:false });
    entry.addEventListener('keydown', (event) => { if (['ArrowDown','PageDown',' ','Enter'].includes(event.key)) { event.preventDefault(); update(.22); } });
    entry.querySelector('[data-entry-skip]')?.addEventListener('click', finish);
    entry.tabIndex = -1;
    entry.focus();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('[data-variant-select]').forEach((select) => select.addEventListener('change', () => {
    const price = select.closest('.ca-product__details')?.querySelector('[data-product-price]');
    if (price) price.textContent = select.selectedOptions[0].dataset.price;
  }));

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const items = [...gallery.querySelectorAll('[data-gallery-item]')];
    const counter = gallery.querySelector('[data-gallery-count]');
    if (!counter || items.length < 2) return;

    let frame;
    gallery.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const galleryCenter = gallery.scrollLeft + gallery.clientWidth / 2;
        let closest = 0;
        let closestDistance = Infinity;
        items.forEach((item, index) => {
          const itemCenter = item.offsetLeft + item.offsetWidth / 2;
          const distance = Math.abs(itemCenter - galleryCenter);
          if (distance < closestDistance) {
            closest = index;
            closestDistance = distance;
          }
        });
        counter.textContent = `${closest + 1} / ${items.length}`;
      });
    }, { passive: true });
  });

  document.querySelectorAll('[data-pdp-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch || !window.FormData) return;
      event.preventDefault();
      const button = form.querySelector('[data-add-button]');
      const label = button?.querySelector('[data-add-label]');
      const status = form.querySelector('[data-form-status]');
      if (!button || button.disabled) return;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = button.dataset.addingText;
      if (status) status.textContent = '';

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('cart');

        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        const cart = await cartResponse.json();
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
        if (label) label.textContent = button.dataset.addedText;
        if (status) status.textContent = button.dataset.addedText;
        window.setTimeout(() => {
          if (label) label.textContent = button.dataset.idleText;
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }, 1600);
      } catch (error) {
        if (label) label.textContent = button.dataset.idleText;
        if (status) status.textContent = button.dataset.errorText;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];
      document.querySelectorAll('[data-sticky-variant]').forEach((input) => { input.value = select.value; });
      document.querySelectorAll('[data-sticky-price]').forEach((price) => { price.textContent = option.dataset.price; });
    });
  });

  document.querySelectorAll('.ca-product__form input[name="quantity"]').forEach((quantity) => {
    quantity.addEventListener('change', () => {
      document.querySelectorAll('[data-sticky-quantity]').forEach((input) => { input.value = Math.max(1, Number(quantity.value) || 1); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ca-product-recommendations')) {
    customElements.define('ca-product-recommendations', class extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url || this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = new DOMParser().parseFromString(text, 'text/html');
            const recommendations = html.querySelector('ca-product-recommendations');
            if (recommendations?.innerHTML.trim()) this.innerHTML = recommendations.innerHTML;
          })
          .catch(() => { this.hidden = true; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  const menuButton = document.querySelector('[data-menu-button]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileNav.classList.toggle('is-open', !open);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
